import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=24f2b10a&scoped=true&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuModal.vue?vue&type=style&index=0&id=24f2b10a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f2b10a",
  null
  
)

export default component.exports